import * as Sentry from "@sentry/browser";

const LAST_RELOAD_AT_STORAGE_KEY = "staleAssetsLastReloadAt";
const MIN_MILLISECONDS_BETWEEN_RELOADS = 30_000;

export function isDynamicImportError(error: unknown): boolean {
  if (!(error instanceof Error) || typeof error.message !== "string")
    return false;

  // Each browser uses a different message for a failed dynamic import.
  return (
    error.message.includes("Failed to fetch dynamically imported module") || // Chrome/Edge
    error.message.includes("error loading dynamically imported module") || // Firefox
    error.message.includes("Importing a module script failed") // Safari
  );
}

// After a deploy, the previous build's chunks are no longer served, so a tab running
// the old bundle can only recover by reloading. The guard stops a reload loop when
// the chunk is still missing after the reload, e.g. when a deploy is broken. Without
// storage the guard cannot work, so we refrain from reloading at all.
export function reloadForStaleAssets(): boolean {
  try {
    const lastReloadAt = Number(
      window.sessionStorage.getItem(LAST_RELOAD_AT_STORAGE_KEY)
    );
    if (Date.now() - lastReloadAt < MIN_MILLISECONDS_BETWEEN_RELOADS)
      return false;

    window.sessionStorage.setItem(
      LAST_RELOAD_AT_STORAGE_KEY,
      String(Date.now())
    );
  } catch {
    return false;
  }

  Sentry.captureMessage("Reloading page after failing to load assets", "info");
  window.location.reload();
  return true;
}
